export default {"src":"/_next/static/media/e-ticket.b55a77c0.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};